import { SvgIcon, SvgIconProps } from '@material-ui/core';

import copilotBudgetIcon from './copilot-budget.png';

export const CopilotBudgetIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 94 94">
    <image href={copilotBudgetIcon} width="94" height="94" />
  </SvgIcon>
);
